import type { ZodIssue } from 'zod';
import type { PropertyEditFormErrors, PropertyEditFormState } from './types';

const FORM_ERROR_KEYS = new Set<keyof PropertyEditFormState>([
  'propertyCode',
  'submarket',
  'assetType',
  'totalRentableSf',
  'marketingSummary',
  'streetNumber',
  'streetName',
  'streetType',
  'streetDirection',
  'suiteNumber',
  'city',
  'province',
  'postalCode',
  'heroMediaUrls',
]);

export function isPropertyEditFormErrorKey(value: unknown): value is keyof PropertyEditFormState {
  return typeof value === 'string' && FORM_ERROR_KEYS.has(value as keyof PropertyEditFormState);
}

export function mapPropertyEditIssues(issues: ZodIssue[]): PropertyEditFormErrors {
  const next: PropertyEditFormErrors = {};
  for (const issue of issues) {
    const [first, second] = issue.path;

    if (first === 'address' && isPropertyEditFormErrorKey(second)) {
      next[second] ??= issue.message;
      continue;
    }

    if (isPropertyEditFormErrorKey(first)) {
      next[first] ??= issue.message;
    }
  }
  return next;
}
